import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import InputField from '../../../../../component/form/FormInput';
import Modal from '../../../../../component/modal/Modal';
import MeasuringUnitGeneral from './measuringUnitGeneral';
import { toast } from 'react-toastify';
import {
	createMeasuringUnitGeneral,
	deleteMeasuringUnitGeneral,
	getMeasuringUnitGeneral,
	UpdateMeasuringUnitGeneral,
	UpdateMeasuringUnitGeneralStatus,
} from '../../../../../services/settings/inventory';
import search from '../../../../../assets/image/search-status.svg';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function MeasuringUnit({ activeTab }) {
	const [measuringUnitTab, setMeasuringUnitTab] = useState('General');
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [measuringUnitLoader, setMeasuringUnitLoader] = useState({
		isLoader: true,
		isGetData: true,
		isSave: false,
		isStatusId: false,
		isDeleteId: null,
	});
	const [error, setError] = useState(false);
	const [sortDirection, setSortDirection] = useState({});
	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
		search: '',
		filterBy: '',
		filterValue: '',
	});
	const isFirstRender = useRef(true);
	const [measuringUnitList, setMeasuringUnitList] = useState([]);
	const [measuringUnitForm, setMeasuringUnitForm] = useState({
		id: null,
		name: '',
		short_name: '',
		is_active: true,
	});

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};

	const handleFormData = (key, value, required) => {
		setMeasuringUnitForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (value === '' || value === null || value === undefined) {
				newError[key] = `Please enter valid ${key.split('-').join('')} in the field`;
			} else {
				delete newError[key];
			}
			setError(newError);
		}
	};

	const handleDisable = async (id, status) => {
		try {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: true,
				isStatusId: id,
			}));
			const body = {
				is_active: status,
			};
			const res = await UpdateMeasuringUnitGeneralStatus(id, body);
			if (res.success) {
				toast.success(res.message);
				getMeasuringUnitGeneralList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: false,
				isStatusId: null,
			}));
		}
	};
	const handleDelete = async (id) => {
		try {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: true,
				isDeleteId: id,
			}));

			const res = await deleteMeasuringUnitGeneral(id);
			if (res.success) {
				toast.success(res.message);
				getMeasuringUnitGeneralList();
			} else {
				toast.error(res.message);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: false,
				isDeleteId: null,
			}));
		}
	};
	const handleOpenModel = (index) => {
		var data = measuringUnitList[index];
		setMeasuringUnitForm((prev) => ({
			...prev,
			id: data.id,
			name: data.name,
			short_name: data.short_name,
			is_active: data.is_active,
		}));
		setError({});
		setIsOpenModal(true);
	};

	const resetForm = () => {
		setMeasuringUnitForm({
			id: null,
			name: '',
			short_name: '',
			is_active: true,
		});
	};

	function checkValidation() {
		const newError = { ...error };

		if (
			!measuringUnitForm.name ||
			measuringUnitForm.name === '' ||
			measuringUnitForm.name === undefined
		) {
			newError.name = newError.name || 'Please enter measuring unit name in the field';
		} else {
			delete newError.name;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handlePackagingGeneral = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				`Measuring Unit ${measuringUnitForm.id !== null ? 'update' : 'create'} failed! Please fill required fields.`,
			);
		} else {
			try {
				setMeasuringUnitLoader((prev) => ({
					...prev,
					isLoader: true,
					isSave: true,
				}));
				var body = {
					name: measuringUnitForm.name,
					short_name: measuringUnitForm.short_name,
					is_active: measuringUnitForm.is_active,
				};
				var res;
				if (measuringUnitForm.id !== null) {
					res = await UpdateMeasuringUnitGeneral(measuringUnitForm.id, body);
				} else {
					res = await createMeasuringUnitGeneral(body);
				}
				if (res.success) {
					setIsOpenModal(false);
					toast.success(res.message);
					getMeasuringUnitGeneralList();
				} else {
					toast.error(res.message);
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setMeasuringUnitLoader((prev) => ({
					...prev,
					isLoader: false,
					isSave: false,
				}));
			}
		}
	};
	async function getMeasuringUnitGeneralList() {
		try {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));
			const { units } = await getMeasuringUnitGeneral(params);
			setMeasuringUnitList(units);
		} catch (error) {
			toast.error(error.message || 'Somthing went wrong!');
		} finally {
			setMeasuringUnitLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	}

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // ⛔ skip first render
		}
		const debounceTimer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				search: searchText,
			}));
		}, 500); // ⏱ debounce delay (ms)

		return () => clearTimeout(debounceTimer);
	}, [searchText]);

	useEffect(() => {
		getMeasuringUnitGeneralList();
	}, [params]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				searchComponent={{
					searchText: searchText,
					setSearchText: (value) => setSearchText(value)
				}}
				buttons={[
					{
						id: 1,
						button: 'Add New',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							resetForm();
							setError({});
							setIsOpenModal(true);
						},
						className: 'btn-primary',
					},
				]}
			/>

			<div
				className="py-2"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 52, zIndex: 50 }}
			>
				<ul className="nav mt-2">
					{['General'].map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<div
								className={`tab-link ${measuringUnitTab === item ? 'active' : ''} d-flex align-items-center`}
								onClick={() => {
									setMeasuringUnitTab(item);
								}}
							>
								{item}
							</div>
						</li>
					))}
				</ul>
			</div>
			{measuringUnitTab === 'General' && (
				<MeasuringUnitGeneral
					measuringUnitList={measuringUnitList}
					measuringUnitLoader={measuringUnitLoader}
					sortDataList={sortDataList}
					sortIconMap={sortIconMap}
					sortDirection={sortDirection}
					isOpenModal={isOpenModal}
					setIsOpenModal={setIsOpenModal}
					handleDisable={handleDisable}
					handleDelete={handleDelete}
					handleOpenModel={handleOpenModel}
				/>
			)}
			{isOpenModal && (
				<Modal
					className="currency_model"
					title={`${measuringUnitForm.id !== null ? 'Edit' : 'Add New'}  Measuring Unit`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
					}}
				>
					<div className="d-flex my-3 gap-2">
						<div className="col-6">
							<InputField
								label="Unit Name"
								placeholder="Unit name"
								autoFocus={true}
								type="text"
								required={true}
								value={measuringUnitForm.name}
								onChange={(value) => handleFormData('name', value)}
								error={error?.name}
							/>
						</div>
						<div className="col-6">
							<InputField
								label="Short Name"
								placeholder="Short name"
								type="text"
								required={false}
								value={measuringUnitForm.short_name}
								onChange={(value) => handleFormData('short_name', value)}
								error={error?.short_name}
							/>
						</div>
					</div>
					<div className="d-flex gap-3 align-items-center my-2">
						<div className="fs-5 fw-semibold text-dark">Active</div>
						<div className="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								checked={measuringUnitForm.is_active}
								id="flexCheckDefault"
								onChange={(e) => handleFormData('is_active', !measuringUnitForm.is_active)}
							/>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
							marginTop: '10px',
							gap: '10px',
						}}
					>
						<Button
							type="button"
							button={`Save`}
							disabled={measuringUnitLoader.isLoader && measuringUnitLoader.isSave}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handlePackagingGeneral()}
							loader={measuringUnitLoader.isLoader && measuringUnitLoader.isSave}
						/>
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModal(false)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
}
